import getServiceName from '../getServiceName';
import { createThrottle, getServiceData, resolveThrottle } from '../services';
export const throttleGate = config => {
  const serviceName = getServiceName(config);
  if (!serviceName) {
    return Promise.resolve(config);
  }
  if (config && config.signal && config.signal.addEventListener) {
    config.signal.addEventListener('abort', () => {
      resolveThrottle(serviceName);
    }, {
      once: true
    });
  }
  if (config.disableNovaServiceThrottle) {
    return Promise.resolve(config);
  }
  const throttle = getServiceData(serviceName)?.throttle;
  if (throttle) {
    return throttle.promise.then(() => config);
  }
  config.__throttleId = createThrottle(serviceName);
  return Promise.resolve(config);
};
export const throttleRelease = result => {
  resolveThrottle(getServiceName(result.config));
  return result;
};
export const throttleReleaseError = error => {
  resolveThrottle(getServiceName(error.config));
  return Promise.reject(error);
};
//# sourceMappingURL=throttle.js.map